export default __webpack_public_path__ + "img/585d02fcc326575fe86a92404c6b70e7.jpg";